:host {
  display: block;
}

klevu-typography.caption {
  display: block;
  margin-bottom: var(--klevu-spacing-04);
}

klevu-list:hover {
  cursor: pointer;
  background: var(--klevu-color-neutral-2);
}
